import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import CustomModal from "../customModal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axiosInstance from "../../../../refershTokenManage/axiosConfig";
import CommonLoader from "../../../../loader/CommonLoader";

const ForgotPasswordModal = ({ show, handleClose, userEmail }) => {
    const [formData, setFormData] = useState({
        email: userEmail || "",
        new_password: "",
        c_password: "",
    });
    const [loading, setLoading] = useState(false);
    const [sendEmail, setSendEmail] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({
        email: "",
        new_password: "",
        c_password: ""
    });

    useEffect(() => {
        if (userEmail) {
            setFormData(prev => ({
                ...prev,
                email: userEmail
            }));
        }
    }, [userEmail]);

    useEffect(() => {
        if (!show) {
            setFormData({
                email: "",
                new_password: "",
                c_password: "",
            });
            setFieldErrors({
                email: "",
                new_password: "",
                c_password: ""
            });
            setSendEmail(false);
        }
    }, [show]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (fieldErrors[name]) {
            setFieldErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFieldErrors({
            email: "",
            new_password: "",
            c_password: ""
        });

        try {
            if (formData.new_password !== formData.c_password) {
                setFieldErrors(prev => ({
                    ...prev,
                    c_password: "Passwords do not match!"
                }));
                return;
            }

            setLoading(true);
            const response = await axiosInstance.post('/api/forgot-password', {
                ...formData,
                send_email: sendEmail ? 1 : 0
            });

            toast.success("Password reset successful!");
            handleClose();
        } catch (error) {
            console.error("Password reset error:", error);
            if (error.response?.data?.errors) {
                setFieldErrors(error.response.data.errors);
            } else if (error.response?.data?.error === "User not found.") {
                setFieldErrors(prev => ({
                    ...prev,
                    email: "No account found with this email address."
                }));
            } else {
                toast.error(error.response?.data?.message || "Failed to reset password. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <CustomModal
            show={show}
            handleClose={handleClose}
            headerContent={
                <div>
                    <h4 className="create_user_heading">Reset Password</h4>
                    <p className="fs-5 mt-3 text-muted">
                        Enter your new password below
                    </p>
                </div>
            }
            bodyContent={
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            placeholder="Email"
                            onChange={handleChange}
                            required
                            className={`loginFields ${fieldErrors.email ? 'error' : ''}`}
                            disabled={!!userEmail}
                        />
                        {fieldErrors.email && (
                            <div className="field-error text-danger">
                                {fieldErrors.email}
                            </div>
                        )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Control
                            type="password"
                            name="new_password"
                            value={formData.new_password}
                            placeholder="New Password"
                            onChange={handleChange}
                            required
                            className={`loginFields ${fieldErrors.new_password ? 'error' : ''}`}
                        />
                        {fieldErrors.new_password && (
                            <div className="field-error text-danger">
                                {fieldErrors.new_password}
                            </div>
                        )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Control
                            type="password"
                            name="c_password"
                            value={formData.c_password}
                            placeholder="Confirm Password"
                            onChange={handleChange}
                            required
                            className={`loginFields ${fieldErrors.c_password ? 'error' : ''}`}
                        />
                        {fieldErrors.c_password && (
                            <div className="field-error text-danger">
                                {fieldErrors.c_password}
                            </div>
                        )}
                    </Form.Group>

                    <Form.Group className="mb-3" style={{ marginLeft: '15px' }}>
                        <Form.Check
                            type="checkbox"
                            id="send-email-checkbox"
                            label="Send email notification"
                            checked={sendEmail}
                            onChange={(e) => setSendEmail(e.target.checked)}
                        />
                    </Form.Group>

                    {loading && (
                        <div className="loader-overlay">
                            <CommonLoader />
                        </div>
                    )}
                </Form>
            }
            footerContent={
                <>
                    <Button
                        variant="primary"
                        className="creatrUserSubmit"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        Reset Password
                    </Button>
                    <Button
                        variant="secondary"
                        className="creatrUserClose"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </>
            }
        />
    );
};

export default ForgotPasswordModal; 